import React from 'react';
import PropTypes from 'prop-types';
import MUIDataTable from 'mui-datatables';
// material
import { Box, Container, CircularProgress, Typography, Button } from '@mui/material';

import { createTheme, ThemeProvider } from '@mui/material/styles';
// components
import Page from 'presentation/components/Page';
// local
import { theme } from 'presentation/theme';
import { Add } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import columns from './columns';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    }
}));

const tableTheme = createTheme(
    {
        overrides: {
            MUIDataTableHeadCell: {
                root: {
                    '&:nth-child(1)': {
                        width: '20vw'
                    },
                    '&:nth-child(2)': {
                        width: '20vw'
                    }
                }
            }
        }
    },
    theme
);

function ClientListView(props) {
    const classes = useStyles();

    // get props
    const { clients, rowsPerPageValue, tableMaxPage, loading, handleOnChangeRowsPerPage, handleOnChangePage, isAdmin, handleClick } = props;

    // table options
    const options = {
        filterType: 'checkbox',
        rowsPerPage: rowsPerPageValue,
        rowsPerPageOptions: [5, 10, 15],
        responsive: 'simple', // responsive type
        resizableColumns: false,
        print: false,
        download: false,
        filter: false,
        selectableRows: 'none',
        selectableRowsOnClick: false,
        jumpToPage: true,
        count: tableMaxPage,
        textLabels: {
            body: {
                noMatch: loading ? <CircularProgress /> : 'Sorry, there is no matching data to display'
            }
        },
        onChangeRowsPerPage: handleOnChangeRowsPerPage,
        onChangePage: handleOnChangePage
    };

    return (
        <Page className={classes.root} title="Clients">
            <Container maxWidth={false}>
                <div>
                    <Box display="flex">
                        <Box flexGrow={1}>
                            <Typography color="textPrimary" variant="h2">
                                Clients
                            </Typography>
                        </Box>
                        <Box>
                            {isAdmin && (
                                <Button color="primary" variant="contained" onClick={handleClick} startIcon={<Add />}>
                                    Add client
                                </Button>
                            )}
                        </Box>
                    </Box>
                </div>
                <Box mt={3}>
                    <ThemeProvider theme={tableTheme}>
                        <MUIDataTable data={clients} columns={columns} options={options} />
                    </ThemeProvider>
                </Box>
            </Container>
        </Page>
    );
}

ClientListView.propTypes = {
    // controller state variables
    clients: PropTypes.array.isRequired,
    rowsPerPageValue: PropTypes.number.isRequired,
    tableMaxPage: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    // controller functions
    handleOnChangeRowsPerPage: PropTypes.func.isRequired,
    handleOnChangePage: PropTypes.func.isRequired,
    handleClick: PropTypes.func.isRequired
};

export default ClientListView;
